

import { useState } from 'react';
import { Box, TextField } from '@mui/material';
// import { getCountries, getCountryCallingCode } from 'libphonenumber-js';
function PhoneInput({  countryCode, 
    phoneNumber, 
    onCountryCodeChange, 
    onPhoneNumberChange, 
    valid,
    countryCodes }) {
//   const [countryCode, setCountryCode] = useState('+234');
//   const [phoneNumber, setPhoneNumber] = useState('');

// Get all countries and their codes
// const countryCodes = getCountries().map(country => {
//     try {
//       return {
//         code: `+${getCountryCallingCode(country)}`,
//         country: country,
//       }
//     } catch (error) {
//       console.log(`Error with country: ${country}`, error);
//       return null;
//     }
//   }).filter(Boolean).sort((a, b) => a.code.localeCompare(b.code));
  return (
    <Box sx={{ display: 'flex', gap: 2, my: 2 }}>
      <select
        value={countryCode}
        onChange={(e) => onCountryCodeChange(e.target.value)}
        style={{ 
          width: '80px', 
          height: 'auto', 
          paddingLeft: '6px', 
          paddingRight: '6px', 
          borderRadius: '8px', 
          cursor: 'pointer',
          background: valid ? 'rgba(86, 4, 246, 1)' : 'rgba(210, 209, 214, 0.3)',
          color: valid ? '#fff' : '#000'
        }}
      >
        {countryCodes.map((country) => (
          <option key={country.id} value={country.code}>
            {country.code}
          </option>
        ))}
      </select>

      <TextField
        size="small"
        value={phoneNumber}
        onChange={(e) => onPhoneNumberChange(e.target.value)}
        placeholder="Recipient Number"
        fullWidth
        sx={{ fontWeight: 300, color: '#000', borderRadius: '10px' }}
      />
    </Box>
  );
//   return (
//     <Box sx={{ display: 'flex', gap: 2, my: 2 }}>
//       <select 
//         value={countryCode}
//         onChange={(e) => setCountryCode(e.target.value)}
//         style={{ width: '80px', height: 'auto', paddingLeft: '6px', paddingRight: '6px', borderRadius:'8px', cursor:'pointer', background: valid ? 'rgba(86, 4, 246, 1)':'rgba(210, 209, 214, 0.3)', color: valid ?'#fff': '$'}}
//       >
//         {countryCodes.map((country) => (
//           <option key={country.id} value={country.code}>
//             {country.code}
//           </option>
//         ))}
//       </select>

//       <TextField
//        size="small"
//         value={phoneNumber}
//         onChange={(e) => setPhoneNumber(e.target.value)}
//         placeholder="Recepient Number"
//         fullWidth
//         sx={{fontWeight: 300, color: '#000', borderRadius: '10px'}}
//       />
//     </Box>
//   );
}

export default PhoneInput;

